import { Component, OnInit } from '@angular/core';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-secondary-footer',
  templateUrl: './secondary-footer.component.html',
  styleUrls: ['./secondary-footer.component.css']
})
export class SecondaryFooterComponent implements OnInit {
  currentYear = new Date().getFullYear();
  appVersion = environment.APP_VERSION;

  constructor() { }

  ngOnInit() {
  }

}
